import ErrorState from '@ui/components/ErrorState';

export default function RouteErrorBoundary() {
  return <ErrorState />;
}
